import { useTranslation } from 'react-i18next'

import { RadioGroup } from '@reveni-io/reveni-ui'

import { booleanOptions } from './constants'

const BooleanInput = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()

  const options = booleanOptions.map(option => ({
    label: t(option.labelKey),
    value: option.value,
  }))

  return (
    <RadioGroup
      label={t('Valor')}
      options={options}
      onChange={e => onChange(e.target.value)}
      value={value ?? ''}
      orientation="column"
      disabled={disabled}
    />
  )
}

export default BooleanInput
